"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTenantBody = exports.PlatformTenantSummary = exports.ProvisionTenantResult = exports.ProvisionTenantBody = exports.TenantStatuses = exports.TENANT_SUBDOMAIN_RE = void 0;
// Platform (super_admin) tenant-management contracts — sub-project 3 onboarding.
// These back the `/api/v1/admin/platform/tenants` surface, gated on the
// `platform.tenants.manage` permission (super_admin only).
const zod_1 = require("zod");
const enums_js_1 = require("./enums.js");
// Subdomain slug: lowercase alphanumeric + internal hyphens, 2–63 chars
// (DNS label rules). Reserved labels are rejected server-side.
exports.TENANT_SUBDOMAIN_RE = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
exports.TenantStatuses = ['active', 'suspended'];
exports.ProvisionTenantBody = zod_1.z.object({
    name: zod_1.z.string().min(1).max(128),
    subdomain: zod_1.z.string().min(2).max(63).regex(exports.TENANT_SUBDOMAIN_RE),
    admin_username: zod_1.z.string().min(1).max(64),
    admin_display_name: zod_1.z.string().min(1).max(128).optional(),
    locale: zod_1.z.enum(enums_js_1.Locales).optional(),
});
// The provisioning response — `temp_password` is returned EXACTLY ONCE; it is
// never persisted in plaintext nor logged. The operator must hand it to the
// new tenant admin, who should change it on first login.
exports.ProvisionTenantResult = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    subdomain: zod_1.z.string(),
    status: zod_1.z.enum(exports.TenantStatuses),
    admin_username: zod_1.z.string(),
    temp_password: zod_1.z.string(),
});
exports.PlatformTenantSummary = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    subdomain: zod_1.z.string().nullable(),
    custom_domain: zod_1.z.string().nullable(),
    status: zod_1.z.enum(exports.TenantStatuses),
    counts: zod_1.z.object({
        users: zod_1.z.number().int().nonnegative(),
        resources: zod_1.z.number().int().nonnegative(),
        composers: zod_1.z.number().int().nonnegative(),
        players: zod_1.z.number().int().nonnegative(),
    }),
    created_at: zod_1.z.string(),
});
exports.UpdateTenantBody = zod_1.z
    .object({
    name: zod_1.z.string().min(1).max(128).optional(),
    subdomain: zod_1.z.string().min(2).max(63).regex(exports.TENANT_SUBDOMAIN_RE).nullable().optional(),
    custom_domain: zod_1.z.string().min(1).max(253).nullable().optional(),
    // P7: per-tenant media storage quota in bytes. null clears the override
    // (falls back to the platform-wide env default, itself unset = unlimited).
    storage_quota_bytes: zod_1.z.number().int().nonnegative().nullable().optional(),
})
    .refine((b) => Object.keys(b).length > 0, { message: 'empty_patch' });
//# sourceMappingURL=platform.schema.js.map